import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Elearnsimple: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi E-learn simple Sekolah" />
    <h1><strong><a href="/elearnsimple/">E-learn Simple</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/5478Z4t4Pjw" title="pembuatan aplikasi e-learn sekolah"></iframe>
</div>
    <p>
Untuk kebutuhan akan proses belajar mengajar semakin lebih sempurna dengan menggunakan aplikasi e-learn simple ini untuk digunakan dalam menunjang guru dan murid , dengan fitur sebagai berikut :
    </p>
    <p>Siswa apps : homepage dashboard siswa , list ujian dan tugas lengkap dengan status nya baik yang sudah dikerjakan maupun yang belum dikerjakan, memulai proses latihan pelajaran sekolah online , menjawab materi soal dari guru, nilai otomatis setelah siswa menyelesaikan tugas nya, log out keluar dari aplikasi .</p>
<p>Guru admin apps : homepage dashboard area guru dan admin, regristasi mendaftarkan siswa untuk mengikuti ujian atau tugas elearn online , membuat tugas dan ujian disertai dengan materi soal dan optional pilihan jawaban untuk membantu memudahkan siswa untuk belajar, memasukan daftar siswa peserta ujian bisa digunakan untuk remidi siswa,  laporan hasil nilai ujian siswa , log out keluar dari aplikasi elearning online sekolah.</p>
<div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/cfHp2_Xlfbc" title="pembuatan aplikasi e-learn sekolah"></iframe>
</div>
<p>Semakin mudah dengan dukungan APK android dalam bekerja untuk mobilitas pada aktivitas belajar mengajar</p>
<p>daftar harga layanan per tahun : 
<br/>E-learn simple Apps
<br/>Free Domain .sch.id
<br/>Web Space 1.5GB
<br/>Include Host
<br/>axcora school cms website
<br/>website sekolah
<br/>APK Android Guru
<br/>APK Android Siswa
<br/>Rp.2.512.300</p>
<a href="https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/sekolah%20%3A%0AAlamat%20%3A%0APaketwebapp%20elearn-simpletandard%3A%0APrice%20%3ARp.2.512.300/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0ABRI%20008601112564504%20Soni%20Andrias%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Order Now</a>
<br/>    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Elearnsimple

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
